import { DialogService, GridAction } from '@eforall/dashboard';
import { AcceleratorCourseAssignment } from '@interfaces';
import { ExperienceAreaService } from '../../../../experience-area.service';
import { AccClassEventsViewerDialog } from '../acc-class-events-viewer-dialog/acc-class-events-viewer.dialog';

export function getActions(dialog: DialogService, expAreaService: ExperienceAreaService) {

	const actions: GridAction<AcceleratorCourseAssignment>[] = [
		{
			iconClass: 'fa-regular fa-calendar',
			label: 'Generate Class Events',
			isEnabled: rows => !!rows.length && expAreaService.canEdit() && !rows[0]!.classEventsGenerated,
			execute: async rows => {
				const events = await expAreaService.generateAccClassEvents(rows[0]!.accId);

				if (events) {
					await dialog.showCustom(AccClassEventsViewerDialog, { data: { accName: rows[0]!.name, events } }, 900, 550);
					await expAreaService.reloadData();
				}

			}
		},
	];

	return actions;
}
